var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C6.7 18 4.69567 17.2373 2.987 15.712C1.27833 14.1867 0.299333 12.2827 0.05 10H2.1C2.33333 11.7333 3.10433 13.1667 4.413 14.3C5.72167 15.4333 7.25067 16 9 16C10.95 16 12.6043 15.3207 13.963 13.962C15.3217 12.6033 16.0007 10.9493 16 9C16 7.05 15.3207 5.39567 13.962 4.037C12.6033 2.67833 10.9493 1.99933 9 2C7.85 2 6.775 2.26667 5.775 2.8C4.775 3.33333 3.93333 4.06667 3.25 5H6V7H0V1H2V3.35C2.85 2.28333 3.88767 1.45833 5.113 0.875C6.33833 0.291667 7.634 0 9 0C10.25 0 11.421 0.237667 12.513 0.713C13.605 1.18833 14.555 1.82967 15.363 2.637C16.171 3.44567 16.8127 4.39567 17.288 5.487C17.7633 6.57833 18.0007 7.74933 18 9C18 10.25 17.7623 11.421 17.287 12.513C16.8117 13.605 16.1703 14.555 15.363 15.363C14.5543 16.171 13.6043 16.8127 12.513 17.288C11.4217 17.7633 10.2507 18.0007 9 18ZM11.8 13.2L8 9.4V4H10V8.6L13.2 11.8L11.8 13.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineBinIcon);
export default __webpack_public_path__ + "static/media/MedicineBinIcon.91dc3e91f8c5504601dcdbc6a57083ff.svg";
export { ForwardRef as ReactComponent };